<template>
    <section class="section-hero section-shaped my-0">
        <div class="shape shape-style-1 shape-primary">
            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        <img :src="data.img" style="width: 200px;" class="img-fluid">
                        <!--<h1 class="text-white">Rushnett</h1>-->
                        <p class="lead text-white mt-4 mb-5">A website for all things Nick. A near limitless supply of
                            accounts I barely use.</p>
                        <div class="btn-wrapper">
                            <base-button
                                    v-for="button in data.buttons"
                                    tag="a"
                                    @click="$router.push({name: button.dest})"
                                    :class="button.class"
                                    :type="button.type">
                                <font-awesome-icon :icon="button.fa.icon" :size="button.fa.size"></font-awesome-icon>
                                {{ button.title }}
                            </base-button>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center justify-content-around stars-and-coded">
                    <!--<div class="col-sm-4">
                        <span class="text-white alpha-7 ml-3">Star us on</span>
                        <a href="https://github.com/creativetimofficial/argon-design-system" target="_blank" title="Support us on Github">
                            <img src="img/brand/github-white-slim.png" style="height: 22px; margin-top: -3px">
                        </a>
                    </div>-->
                    <!--<div ref="porto" class="col-sm-4 mt-4 mt-sm-0 text-right">
                        <span class="text-white alpha-7">Coded by</span>
                        <a href="https://www.creative-tim.com" target="_blank" title="Creative Tim - Premium Bootstrap Themes and Templates">
                            <img src="img/brand/creativetim-white-slim.png" class="ml-3" style="height: 30px;">
                        </a>
                    </div>-->
                </div>
            </div>
        </div>
    </section>
</template>
<script>
  // help from here:
  // https://auth0.com/blog/vuejs-kanban-board-adding-progressive-web-app-features/
  let installEvent
  export default {
    name: 'installPrompt',
    data () {
      return {
        data: require('../../../public/details/main_page'),
        showInstallBanner: false
      }
    },
    created () {
      window.addEventListener('beforeinstallprompt', e => {
        e.preventDefault()
        installEvent = e
        this.showInstallBanner = true
      })
    },
    methods: {
      install () {
        this.showInstallBanner = false
        installEvent.prompt()
        installEvent.userChoice.then(() => {
          installEvent = null
        })
      }
    }
  }
</script>
<style>
</style>
